import EnvirotainerState from "./Envirotainer/EnvirotainerState";
import { PT300State } from "./PT300/PT300State";
import State from "./State";

export const parseState = (data: any, deviceType: any): State => {
	switch (deviceType.toUpperCase()) {
		case "ENVIROTAINER": {
			return new EnvirotainerState(data);
		}
		case "PT300D":
		case "PT300": {
			return new PT300State(data);
		}
		default:
			return new EnvirotainerState(data);
	}
};
